import { Controller } from '@hotwired/stimulus'

export default class PopoverController extends Controller {
  connect () {
    this.popoverInstance = new bootstrap.Popover(this.element, { html: true });
  }

  disconnect () {
    this.popoverInstance.dispose();
  }
}
